// Concentric rings. Point count scales with radius so density stays even
// instead of bunching at the centre. Planar, so z is 0 — see grid.js.
import { mulberry32 } from '../rng.js'

export default {
  id: 'polar',
  label: 'Polar',
  motion: 'resample',
  params: [
    { key: 'density', label: 'density', tier: 'structural', min: 6, max: 80, step: 1, default: 34 },
    { key: 'spin', label: 'ring offset', tier: 'structural', min: 0, max: 1, step: 0.02, default: 0.3 },
    { key: 'jitter', label: 'jitter', tier: 'structural', min: 0, max: 1, step: 0.02, default: 0 },
  ],

  build(cfg, seed) {
    const rnd = mulberry32(seed)
    const rings = Math.max(3, Math.round(cfg.density * 0.55))
    const out = []
    const runs = new Int32Array(rings)
    for (let r = 1; r <= rings; r++) {
      const rr = r / rings
      const count = Math.max(6, Math.round(rr * cfg.density * 2.4))
      runs[r - 1] = count
      const offset = r * cfg.spin
      for (let k = 0; k < count; k++) {
        const a = ((k / count) + offset) * Math.PI * 2
        const rad = rr + (rnd() - 0.5) * (cfg.jitter / rings)
        out.push(Math.cos(a) * rad, Math.sin(a) * rad, 0)
      }
    }
    // Each ring is a closed loop, so a path mark joins its last point to its first.
    return { points: Float32Array.from(out), count: out.length / 3, runs, closed: true }
  },
}
